var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"AddFriendListBtn btn ghost btn__round",attrs:{"href":"#"},on:{"click":_vm.addFriendsList}},[_vm._v("\n    "+_vm._s(_vm.$t('BUTTON.NEW_LIST'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }